import Zendesk from 'react-zendesk';
import { ReactElement } from 'react';

export function ZendeskChat({ children }: React.PropsWithChildren): ReactElement | null {
    if (import.meta.env.VITE_PUBLIC_ZENDESK_KEY === undefined) {
        return null;
    }

    return (
        <>
            {children}
            <Zendesk defer zendeskKey={import.meta.env.VITE_PUBLIC_ZENDESK_KEY} />
        </>
    );
}
